import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import { client, HttpException, type operations } from '@/libs/openapi';
import { queryNamespace } from '@/utils/query-namespace.util';

export const publicationQueries = queryNamespace('publication', {
  articles: (data: operations['publications-publication_articles']['parameters']['path'] & operations['publications-publication_articles']['parameters']['query']) => infiniteQueryOptions({
    queryKey: [data],
    queryFn: (options) => client
      .GET('/api/v1/publications/articles/{publication_id}', {
        params: {
          path: { publication_id: data.publication_id },
          query: { ...data, page: options.pageParam, page_size: data.page_size ?? 100 },
        },
        signal: options.signal
      })
      .then(({ data, error, response }) => {
        if (error) {
          throw new HttpException({ message: error.detail?.map(item => item.msg).join(', '), response });
        }

        return {
          ...data,
          articles: data.articles.map((article) => ({
            ...article,
            excluded: false,
          })),
        };
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (!lastPage || lastPage.page === 100 || lastPage.total < lastPage.page_size) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
      if (firstPageParam <= 1) {
        return undefined;
      }
      return firstPageParam - 1;
    },
  }),
  search: (data: operations['publications-search_publications']['parameters']['query']) => infiniteQueryOptions({
    queryKey: [data],
    queryFn: (options) => client
      .GET('/api/v1/publications/search', {
        params: {
          query: {
            ...data,
            page: options.pageParam,
            page_size: data.page_size ?? 100,
          }
        },
        signal: options.signal
      }).then(({ data, error, response }) => {
        if (error) {
          throw new HttpException({ message: error.detail?.map(item => item.msg).join(', '), response });
        }

        return data;
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (!lastPage || lastPage.page === 100 || lastPage.total < lastPage.page_size) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
      if (firstPageParam <= 1) {
        return undefined;
      }
      return firstPageParam - 1;
    },
    placeholderData: keepPreviousData,
  }),
});
